function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business performance rupess") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M104.133,263h21.238a6,6,0,1,0,0-12H104.056A144.17,144.17,0,0,1,211,116.423V111.8C136,115.378,76.617,176,74.056,251H95.371a6,6,0,0,1,0,12H74.133C77.69,336,137,395.916,211,399.459V394.8C151.538,378.942,107.194,325.816,104.133,263Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.927,112.421q-4.92-.513-9.927-.693V113.8Q227.907,112.941,232.927,112.421Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,397.446v2.094q5.1-.173,10.054-.691Q227.972,398.323,223,397.446Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,348a6,6,0,0,0,0-12H319a6,6,0,0,0,0,12h17.169a19.957,19.957,0,0,1,18.805,14H319a6,6,0,0,0,0,12h35.974c-2.547,8-10.011,13-18.805,13H319a6.258,6.258,0,0,0-4.121,10.712l42.912,40.609a5.981,5.981,0,0,0,8.482-.2,6.278,6.278,0,0,0-.24-8.709L334.085,399h2.084c15.452,0,28.353-11,31.167-25H379a6,6,0,0,0,0-12H367.336A33.672,33.672,0,0,0,361,348Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.365,152.811a13.774,13.774,0,0,0,0-19.481L359.535,121.5a13.774,13.774,0,0,0-19.48,0L324.2,137.2a153.4,153.4,0,0,0-80.2-36.05V80h10.559A13.271,13.271,0,0,0,268,66.505V49.774A13.508,13.508,0,0,0,254.559,36H191.44A13.508,13.508,0,0,0,178,49.774V66.505A13.271,13.271,0,0,0,191.44,80H202v21.152C126,111.572,67.15,176.9,67.15,255.691c0,85.33,68.792,154.865,153.863,155.974a5.791,5.791,0,0,0,1.044.257c.312,0,.578.078.877.078H223a156.669,156.669,0,0,0,39.935-5.314,6.057,6.057,0,0,0-3.073-11.718A142.531,142.531,0,0,1,228,399.6V377.327a6,6,0,0,0-12,0V399.52A143.672,143.672,0,0,1,79.173,263h21.238a6,6,0,0,0,0-12H79.1C81.658,176,141,115.438,216,111.863V134.11a6,6,0,0,0,12,0V111.788C303,114.386,364.32,175,366.9,251H343.627a6,6,0,1,0,0,12h23.188a148.035,148.035,0,0,1-4.094,27.832,5.922,5.922,0,0,0,4.369,7.2,6.023,6.023,0,0,0,7.274-4.406A156.809,156.809,0,0,0,379,255.71a155.114,155.114,0,0,0-25.358-85.166ZM257,66.226A1.774,1.774,0,0,1,255.226,68H191.774A1.774,1.774,0,0,1,190,66.226V49.774A1.774,1.774,0,0,1,191.774,48h63.452A1.774,1.774,0,0,1,257,49.774ZM214,80h18V99.976c-3-.182-6.027-.285-9.15-.285-.148,0-.221.006-.369.006-.177-.016-.318-.027-.5-.027a3.457,3.457,0,0,0-.522.043c-2.558.027-5.46.114-7.46.263Zm119.173,65.352,15.367-15.367a1.776,1.776,0,0,1,2.509,0l11.831,11.829a1.777,1.777,0,0,1,0,2.51l-16.291,16.291A157.474,157.474,0,0,0,333.173,145.352Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.763,252H229V183.068a6,6,0,1,0-12,0v74.719A5.978,5.978,0,0,0,222.749,264h56.014a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,284a96,96,0,1,0,96,96A96.108,96.108,0,0,0,349,284Zm0,180a84,84,0,1,1,84-84A84.1,84.1,0,0,1,349,464Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.56fa261471a88e0c6fe9f423e01246b9.svg";
export { ForwardRef as ReactComponent };